import { render, staticRenderFns } from "./PackageContributors.vue?vue&type=template&id=711f4f2a&scoped=true"
import script from "./PackageContributors.vue?vue&type=script&lang=js"
export * from "./PackageContributors.vue?vue&type=script&lang=js"
import style0 from "./PackageContributors.vue?vue&type=style&index=0&id=711f4f2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711f4f2a",
  null
  
)

export default component.exports